<template>
	<div class="Capitulo4">
		
		<h1>DOS PROCEDIMENTOS ADMINISTRATIVOS</h1>

		<h2>Seção I - Dos Procedimentos Gerais</h2>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 55.</strong> O pedido instruído pelo interessado deve ser analisado conforme a sua natureza, observadas as normas municipais, em especial as prescrições da LOE, PDE, LPUOS, sem prejuízo da observância das disposições estaduais e federais pertinentes.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 1º </strong>O pedido deve ser instruído com todos os elementos necessários à sua apreciação, nos termos das normas legais e regulamentares.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 2º </strong>Todos os documentos exigidos para a instrução dos pedidos podem ser substituídos por equivalentes eletrônicos ou por documentos disponíveis nos cadastros e bancos de dados da Prefeitura.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 3º </strong>Os diversos pedidos referentes ao mesmo imóvel, bem como os recursos contra os respectivos despachos, podem ser analisados em um único processo.</p>
		<p class="corpo_lei"><strong class="bolinha">Art. 56.</strong> O pedido deve ser deferido se o processo estiver devidamente instruído e o projeto observar a legislação pertinente à matéria.</p>
		<p class="corpo_lei"><strong class="bolinha">Art. 57.</strong> O processo que apresentar elementos incompletos ou incorretos ou necessitar de complementação da documentação ou esclarecimentos deve ser objeto de um único comunicado (“comunique-se”) para que as falhas sejam sanadas.</p>

		<!-- 04_capitulo-IV_d01.html -->
		<div id="g-04_capitulo-IV_d01-box" class="ai2html">
			<div id="g-04_capitulo-IV_d01-01" class="g-artboard g-artboard-v4" data-min-width='960'>
				<img id="g-04_capitulo-IV_d01-01-img" class="g-aiImg" :src="caminho + '04_capitulo-IV_d01-01.png'"/>
				<div id="g-ai0-1" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:2.3191%;margin-top:-11.4px;left:0%;width:422px;">
					<p class="g-pstyle0">ANDAMENTO DOS PROCESSOS ADMINISTRATIVOS</p>
				</div>
				<div id="g-ai0-2" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:2.2514%;margin-top:-9.8px;left:89.3911%;width:116px;">
					<p class="g-pstyle1">Lei Art. 56 e 57</p>
				</div>
				<div id="g-ai0-3" class="g-Camada_2 g-aiAbs" style="top:10.1302%;left:38.3598%;margin-left:-76.5px;width:15.9375%;">
					<p class="g-pstyle2">Pedido de acordo com a legislação</p>
				</div>
				<div id="g-ai0-4" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:11.274%;margin-top:-5px;left:46.9974%;width:24px;">
					<p class="g-pstyle3"> </p>
				</div>
				<div id="g-ai0-5" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:16.8994%;margin-top:-12.5px;left:76.7029%;width:166px;">
					<p class="g-pstyle4">PEDIDO DEFERIDO(1) </p>
				</div>
				<div id="g-ai0-6" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:17.1269%;margin-top:-10.5px;left:9.1052%;width:102px;">
					<p class="g-pstyle5"><span class="g-cstyle0">A</span>UT<span class="g-cstyle1">U</span><span class="g-cstyle2">A</span><span class="g-cstyle3">Ç</span><span class="g-cstyle2">Ã</span><span class="g-cstyle4">O</span></p>
				</div>
				<div id="g-ai0-7" class="g-Camada_2 g-aiAbs" style="top:18.7807%;left:13.1771%;margin-left:-76.5px;width:15.9375%;">
					<p class="g-pstyle6">Pedido é enviado para análise da Prefeitura</p>
				</div>
				<div id="g-ai0-8" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:28.6231%;margin-top:-12.5px;left:56.3468%;width:160px;">
					<p class="g-pstyle4">&ldquo;COMUNIQUE-SE&rdquo;(2) </p>
				</div>
				<div id="g-ai0-9" class="g-Camada_2 g-aiAbs" style="top:28.6833%;left:38.4639%;margin-left:-76.5px;width:15.9375%;">
					<p class="g-pstyle2">Pedido sujeito a complementações e/ou esclarecimentos</p>
				</div>
				<div id="g-ai0-10" class="g-Camada_2 g-aiAbs" style="top:30.6183%;left:63.6549%;margin-left:-76.5px;width:15.9375%;">
					<p class="g-pstyle6">Prefeitura emite comunicado único solicitando alterações no pedido</p>
				</div>
				<div id="g-ai0-11" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:42.7825%;margin-top:-18.9px;left:42.5441%;margin-left:-92.5px;width:185px;">
					<p class="g-pstyle7">NÃO ATENDIMENTO AO</p>
					<p class="g-pstyle7">&ldquo;COMUNIQUE-SE&rdquo;</p>
				</div>
				<div id="g-ai0-12" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:42.8588%;margin-top:-18.5px;left:83.2884%;margin-left:-75px;width:150px;">
					<p class="g-pstyle7">ATENDIMENTO AO</p>
					<p class="g-pstyle7">&ldquo;COMUNIQUE-SE&rdquo;</p>
				</div>
				<div id="g-ai0-13" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:57.724%;margin-top:-10.1px;left:63.2168%;margin-left:-81.5px;width:163px;">
					<p class="g-pstyle7">2&ordm; &ldquo;COMUNIQUE-SE&rdquo;</p>
				</div>
				<div id="g-ai0-14" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:58.7861%;margin-top:-12.5px;left:13.5978%;width:180px;">
					<p class="g-pstyle4">PEDIDO INDEFERIDO(3) </p>
				</div>
				<div id="g-ai0-15" class="g-Camada_2 g-aiAbs" style="top:60.0983%;left:63.6729%;margin-left:-84px;width:17.5%;">
					<p class="g-pstyle6">Admite-se a emissão de comunicado complementar para os casos listados no <span class="g-cstyle5">Art. 48 &sect;3&ordm; do Decreto da Lei</span></p>
				</div>
				<div id="g-ai0-16" class="g-Camada_2 g-aiAbs" style="top:75.692%;left:8.4375%;width:24.375%;">
					<p class="g-pstyle8">Os pedidos realizados devem ser deferidos se o processo estiver devidamente instruído e o projeto observar a legislação pertinente à matéria.</p>
					<p>&nbsp;</p>
					<p class="g-pstyle9">O<span class="g-cstyle3"> </span>p<span class="g-cstyle0">r</span><span class="g-cstyle3">o</span>cess<span class="g-cstyle3">o q</span>ue<span class="g-cstyle3"> </span>ap<span class="g-cstyle0">r</span>esen<span class="g-cstyle6">t</span>ar<span class="g-cstyle3"> </span>e<span class="g-cstyle3">l</span>emen<span class="g-cstyle4">t</span><span class="g-cstyle3">o</span>s in<span class="g-cstyle3">co</span>m<span class="g-cstyle7">p</span>le<span class="g-cstyle4">t</span><span class="g-cstyle3">o</span><span class="g-cstyle4">s </span><span class="g-cstyle3">o</span>u in<span class="g-cstyle3">co</span><span class="g-cstyle8">r</span><span class="g-cstyle0">r</span>e<span class="g-cstyle4">t</span><span class="g-cstyle3">o</span>s <span class="g-cstyle3">ou</span> ne<span class="g-cstyle3">c</span>essi<span class="g-cstyle6">t</span>ar de <span class="g-cstyle3">co</span>m<span class="g-cstyle7">p</span><span class="g-cstyle3">l</span>e<span class="g-cstyle3">m</span>en<span class="g-cstyle6">t</span>a<span class="g-cstyle3">ç</span>ã<span class="g-cstyle4">o </span><span class="g-cstyle3">d</span>a <span class="g-cstyle3">do</span>c<span class="g-cstyle3">um</span>en<span class="g-cstyle6">t</span>açã<span class="g-cstyle3">o</span> <span class="g-cstyle3">o</span>u es<span class="g-cstyle9">c</span><span class="g-cstyle3">l</span>a<span class="g-cstyle1">r</span>e<span class="g-cstyle3">c</span>i<span class="g-cstyle3">m</span>en<span class="g-cstyle4">t</span><span class="g-cstyle3">o</span>s <span class="g-cstyle4">de</span><span class="g-cstyle1">v</span><span class="g-cstyle4">e ser </span><span class="g-cstyle1">o</span><span class="g-cstyle4">bje</span><span class="g-cstyle1">t</span><span class="g-cstyle4">o de um único comunicado (</span><span class="g-cstyle10">C</span><span class="g-cstyle4">OM</span><span class="g-cstyle10">U</span><span class="g-cstyle4">NIQUE</span><span class="g-cstyle11">-</span><span class="g-cstyle4">SE) </span><span class="g-cstyle12">p</span>a<span class="g-cstyle13">r</span>a <span class="g-cstyle3">qu</span>e as <span class="g-cstyle0">f</span>al<span class="g-cstyle3">h</span>as seja<span class="g-cstyle3">m</span> sana<span class="g-cstyle3">d</span>as<span class="g-cstyle4">.</span></p>
				</div>
				<div id="g-ai0-17" class="g-Camada_2 g-aiAbs" style="top:75.692%;left:41.9792%;width:24.375%;">
					<p class="g-pstyle8">Os pedidos devem ser indeferidos nos casos de:</p>
					<p>&nbsp;</p>
					<p>a<span class="g-cstyle3">u</span>sência <span class="g-cstyle3">d</span>a d<span class="g-cstyle3">o</span>c<span class="g-cstyle3">um</span>en<span class="g-cstyle6">t</span>a<span class="g-cstyle3">ç</span>ão exi<span class="g-cstyle3">g</span>i<span class="g-cstyle3">d</span>a <span class="g-cstyle3">ou</span> p<span class="g-cstyle1">r</span>oje<span class="g-cstyle4">to </span>ap<span class="g-cstyle1">r</span>esen<span class="g-cstyle6">t</span>a<span class="g-cstyle3">do</span> <span class="g-cstyle3">c</span>o<span class="g-cstyle3">m</span> ins<span class="g-cstyle3">u</span>ﬁ<span class="g-cstyle3">c</span>iên<span class="g-cstyle3">c</span>ia <span class="g-cstyle3">d</span>e in<span class="g-cstyle14">f</span><span class="g-cstyle3">o</span><span class="g-cstyle8">r</span><span class="g-cstyle3">m</span>a<span class="g-cstyle3">ç</span>ão <span class="g-cstyle3">d</span><span class="g-cstyle4">e </span><span class="g-cstyle3">m</span>o<span class="g-cstyle3">do</span> a i<span class="g-cstyle3">m</span>pe<span class="g-cstyle3">d</span>i<span class="g-cstyle3">r</span> a aná<span class="g-cstyle3">l</span>ise e <span class="g-cstyle3">d</span>e<span class="g-cstyle3">c</span>isão <span class="g-cstyle3">d</span>o pedi<span class="g-cstyle3">do</span><span class="g-cstyle4">;</span></p>
					<p>&nbsp;</p>
					<p>p<span class="g-cstyle1">r</span><span class="g-cstyle3">o</span>je<span class="g-cstyle4">t</span><span class="g-cstyle3">o</span> <span class="g-cstyle3">c</span>o<span class="g-cstyle3">m</span> in<span class="g-cstyle3">f</span><span class="g-cstyle13">r</span>a<span class="g-cstyle3">ç</span>ões insan<span class="g-cstyle15">á</span><span class="g-cstyle4">v</span>eis f<span class="g-cstyle0">r</span>en<span class="g-cstyle4">t</span>e a<span class="g-cstyle4">o </span><span class="g-cstyle3">d</span>isp<span class="g-cstyle3">o</span>s<span class="g-cstyle4">t</span><span class="g-cstyle3">o</span> n<span class="g-cstyle3">o</span> <span class="g-cstyle3">PDE</span> e na <span class="g-cstyle16">L</span><span class="g-cstyle3">PU</span>OS<span class="g-cstyle4">;</span></p>
					<p>&nbsp;</p>
				</div>
				<div id="g-ai0-18" class="g-Camada_2 g-aiAbs" style="top:75.692%;left:75.625%;width:24.2708%;">
					<p>nã<span class="g-cstyle3">o</span> a<span class="g-cstyle4">t</span>en<span class="g-cstyle3">d</span>i<span class="g-cstyle3">m</span>en<span class="g-cstyle4">t</span><span class="g-cstyle3">o</span> ao<span class="g-cstyle17"> </span><span class="g-cstyle18">&ldquo;</span><span class="g-cstyle12">C</span>OM<span class="g-cstyle19">U</span><span class="g-cstyle3">N</span>IQU<span class="g-cstyle3">E</span><span class="g-cstyle20">-</span>S<span class="g-cstyle3">E</span>&rdquo; no p<span class="g-cstyle21">r</span>a<span class="g-cstyle4">zo </span><span class="g-cstyle3">l</span>e<span class="g-cstyle3">g</span>a<span class="g-cstyle3">l</span> es<span class="g-cstyle6">t</span>a<span class="g-cstyle3">b</span>eleci<span class="g-cstyle3">d</span>o<span class="g-cstyle4">;</span></p>
					<p>&nbsp;</p>
					<p>não a<span class="g-cstyle4">t</span>en<span class="g-cstyle3">d</span>i<span class="g-cstyle3">m</span>en<span class="g-cstyle4">t</span>o à <span class="g-cstyle3">N</span>EC no p<span class="g-cstyle21">r</span>a<span class="g-cstyle4">z</span><span class="g-cstyle3">o</span> <span class="g-cstyle3">l</span>ega<span class="g-cstyle4">l estabelecido;</span></p>
					<p>&nbsp;</p>
					<p>não a<span class="g-cstyle4">t</span>en<span class="g-cstyle3">d</span>i<span class="g-cstyle3">m</span>en<span class="g-cstyle4">t</span>o à <span class="g-cstyle3">I</span>EOS no p<span class="g-cstyle13">r</span>a<span class="g-cstyle4">z</span><span class="g-cstyle3">o</span> lega<span class="g-cstyle4">l </span>es<span class="g-cstyle6">t</span>abelecid<span class="g-cstyle3">o</span><span class="g-cstyle4">;</span></p>
					<p>&nbsp;</p>
					<p class="g-pstyle8">alteração do uso do projeto de edificação.</p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
				</div>
				<div id="g-ai0-19" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:76.3%;margin-top:-6.9px;left:6.2848%;width:34px;">
					<p class="g-pstyle10">(1)</p>
				</div>
				<div id="g-ai0-20" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:76.3%;margin-top:-6.9px;left:39.9307%;width:34px;">
					<p class="g-pstyle10">(3)</p>
				</div>
				<div id="g-ai0-21" class="g-Camada_2 g-aiAbs g-aiPointText" style="top:84.7%;margin-top:-6.9px;left:6.2848%;width:34px;">
					<p class="g-pstyle10">(2)</p>
				</div>
			</div>
		</div>

		<p class="corpo_lei"><strong class="destaque-lei">Parágrafo único. </strong>O prazo para atendimento do comunicado é de 30 (trinta) dias contados da data da sua publicação, podendo, ser prorrogado, uma única vez, por igual período.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 48. </strong>A chamada do interessado para atendimento de comunicado, também identificado como “comunique-se”, para adequar o projeto à legislação aplicável, apresentar documentos necessários à análise do processo, além daqueles exigidos para cada tipo de pedido, ou prestar esclarecimentos indispensáveis ao prosseguimento da análise do pedido será publicada no DOC. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 1º </strong>O prazo para atendimento do comunicado será de 30 (trinta) dias, contados a partir da data da publicação da chamada no DOC. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 2º </strong>É de inteira responsabilidade do proprietário ou possuidor e dos responsáveis técnicos informar e registrar eventuais correções ou alterações de dados cadastrais constantes do pedido de cada processo. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 3º </strong>A Prefeitura disponibilizará o andamento do processo na internet, com a indicação das publicações de comunicados e despachos no DOC, sendo de inteira responsabilidade do interessado o seu acompanhamento. </p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 49. </strong>Quando forem verificados elementos incompletos ou incorretos ou a necessidade de complementação da documentação ou de esclarecimentos, será emitido um único comunicado especificando todas as exigências a serem atendidas pelo interessado visando cumprir a legislação aplicável ao caso. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 1º </strong>Após o decurso do prazo de atendimento do comunicado, não será admitida a junção de documentos relativos ao seu teor. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 2º </strong>O prazo de atendimento do comunicado emitido poderá ser prorrogado uma única vez, mediante pedido do interessado devidamente justificado, por mais 30 (trinta) dias, contados a partir da data da publicação do despacho de deferimento da prorrogação do prazo no DOC. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 3º </strong>Admite-se a emissão de comunicados complementares, no momento processual adequado, para atendimento, no prazo improrrogável de 30 (trinta) dias, contados da data da publicação da chamada no DOC, uma única vez para cada uma nas seguintes hipóteses: </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">I -</strong> cumprir exigências adicionais estabelecidas por órgão colegiado ou por órgão público que possa estabelecer condições adicionais, pela competência; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">II -</strong> pagamento de outorga onerosa; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">III -</strong> comprovação do cumprimento da cota de solidariedade; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">IV -</strong> apresentação de documentos necessários à formalização de escritura de doação de áreas para alargamento de calçada ou para implantação de outros melhoramentos públicos; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">V -</strong> recolhimento de eventuais diferenças de taxas resultantes da análise do projeto; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">VI -</strong> aviso de DUP ou DIS que ocorrer durante a análise do processo. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 4º </strong>O Diretor de Divisão Técnica ou o Supervisor Técnico de Uso do Solo e Licenciamento poderá emitir ou autorizar a emissão de comunicado complementar ao comunicado emitido quando o seu atendimento resultar em dúvida ou implicar em cumprimento de exigências adicionais. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 5º </strong>Poderá ser autorizada, a qualquer tempo e a critério da chefia, a junção de anuências e pareceres de outros órgãos públicos relacionados ao pedido de licenciamento em andamento. </p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 50. </strong>Por ocasião do despacho de deferimento do Alvará de Aprovação, Alvará de Aprovação e Execução e Alvará de Execução deverão ser consultados os cadastros municipais a respeito da superveniência de DUP ou DIS. </p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 51. </strong>O apostilamento é o meio pelo qual é aditado o documento de controle da atividade edilícia emitido para fazer constar eventuais dados omitidos e retificação de dados, desde que não implique na alteração do projeto, assim como fatos relevantes, tais como suspensão ou anulação de seus efeitos, baixa, transferência e assunção de responsabilidade técnica entre outros. </p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 58. </strong>No pedido de Certificado de Regularização e nos pedidos de Certificado de Acessibilidade e Certificado de Segurança, quando houver necessidade de execução de obras ou serviços para a adaptação da edificação às normas técnicas aplicáveis, podem ser emitidas, respectivamente:</p>
		<p class="corpo_lei"><strong class="destaque-lei">I - </strong>Notificação de Exigências Complementares – NEC, com prazo de até 180 (cento e oitenta) dias;</p>
		<p class="corpo_lei"><strong class="destaque-lei">II - </strong>Intimação para Execução de Obras e Serviços – IEOS, com prazo de até 180 (cento e oitenta) dias.</p>
		<p class="corpo_lei"><strong class="destaque-lei">Parágrafo único. </strong>Nos casos previstos no “caput” deste artigo, a pedido do interessado, por motivo justificado, o prazo pode ser prorrogado uma única vez por igual período.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 59. </strong>O pedido deve ser indeferido nas seguintes situações:</p>
		<p class="corpo_lei"><strong class="destaque-lei">I - </strong>ausência da documentação exigida ou projeto apresentado com insuficiência de informação de modo a impedir a análise e decisão do pedido;</p>
		<p class="corpo_lei"><strong class="destaque-lei">II - </strong>projeto com infrações insanáveis frente ao disposto no PDE e na LPUOS;</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 52. </strong>Nas hipóteses previstas nos incisos I e II do artigo 59 do COE, os pedidos serão imediatamente indeferidos sem a emissão de comunicado.<strong class="subtitulo_txt"></strong></p>
		<p class="corpo_lei"><strong class="destaque-lei">III - </strong>não atendimento ao “comunique-se” no prazo concedido;</p>
		<p class="corpo_lei"><strong class="destaque-lei">IV - </strong>não atendimento à NEC no prazo concedido;</p>
		<p class="corpo_lei"><strong class="destaque-lei">V - </strong>não atendimento à IEOS no prazo concedido;</p>
		<p class="corpo_lei"><strong class="destaque-lei">VI - </strong>alteração do uso do projeto de edificação.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 60. </strong>O prazo para a interposição de recurso é de 30 (trinta) dias a contar da data da publicação do despacho de indeferimento, após o qual o processo deve ser arquivado, sem prejuízo da ação fiscal correspondente e cobrança das taxas devidas.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 61. </strong>Os prazos fixados neste Código são contados em dias corridos, a partir do primeiro dia útil após o evento de origem até o seu dia final inclusive.</p>
		<p class="corpo_lei"><strong class="destaque-lei">Parágrafo único. </strong>Caso não haja expediente no dia final do prazo, prorroga-se automaticamente o seu término para o dia útil imediatamente posterior.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 62. </strong>Os prazos de validade do Alvará de Aprovação e do Alvará de Execução ficam suspensos enquanto perdurar qualquer um dos seguintes impedimentos ao início ou prosseguimento da obra:</p>
		<p class="corpo_lei"><strong class="destaque-lei">I - </strong>decisão judicial determinando ou que implique a paralisação ou o não início da obra;</p>
		<p class="corpo_lei"><strong class="destaque-lei">II - </strong>calamidade pública;</p>
		<p class="corpo_lei"><strong class="destaque-lei">III - </strong>declaração de utilidade pública ou interesse social.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 63. </strong>Os documentos de controle da atividade edilícia de que trata este Código podem, enquanto vigentes, a qualquer tempo, mediante ato da autoridade competente, ser:</p>
		<p class="corpo_lei"><strong class="destaque-lei">I - </strong>revogados, atendendo a relevante interesse público;</p>
		<p class="corpo_lei"><strong class="destaque-lei">II - </strong>cassados, em caso de desvirtuamento, por parte do interessado, da licença concedida ou de descumprimento de exigência estabelecida em sua emissão;</p>
		<p class="corpo_lei"><strong class="destaque-lei">III - </strong>anulados, em caso de comprovação de ilegalidade em sua expedição.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 53. </strong>A cassação e a anulação de Alvarás de Aprovação e de Execução de edificações caberão aos Coordenadores da SMUL e aos Coordenadores de Planejamento e Desenvolvimento Urbano das PRs, no âmbito de suas respectivas competências, na forma estabelecida no COE e neste decreto.<strong class="destaque-decreto"></strong></p>
		<p class="corpo_decreto"><strong class="destaque-decreto">Parágrafo único. </strong>Outros documentos de controle de atividade edilícia poderão ser declarados nulos, observando-se o mesmo procedimento para a anulação de Alvará estabelecido no COE e neste decreto. </p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 64. </strong>O Certificado de Conclusão, o Certificado de Regularização, o Certificado de Acessibilidade e o Certificado de Segurança perdem sua eficácia caso ocorram alterações de ordem física no imóvel em relação às condições regularmente aceitas pela Prefeitura.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 54. </strong>Após a emissão do Certificado de Conclusão ou do Certificado de Regularização de edificação, quando constadas alterações físicas no imóvel ou o desvirtuamento do documento emitido, a edificação será cadastrada como irregular. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">Parágrafo único. </strong>No caso previsto no “caput” deste artigo, a regularização da edificação dependerá da emissão de novo documento de atividade edilícia, na forma prevista no COE e neste decreto.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 65. </strong>O Alvará de Autorização é expedido a título precário, podendo ser cancelado a qualquer tempo por desvirtuamento de seu objeto ou desinteresse em sua manutenção ou revalidação.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 55. </strong>O Alvará de Autorização poderá ser cancelado por despacho da autoridade competente para a sua emissão. </p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 66. </strong>O cadastro de equipamentos perde a eficácia caso ocorra alteração de ordem física no equipamento em relação às condições regularmente cadastradas na Prefeitura ou caso a respectiva renovação não seja solicitada dentro do prazo legal.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 56. </strong>O Cadastro e Manutenção de Equipamentos perderá sua validade quando ocorrer uma das seguintes hipóteses: </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">I -</strong> comprovação da falsidade ou erro das informações prestadas; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">II -</strong> modificações nas características da edificação, no uso, ou na atividade que implique em alteração das regras de segurança; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">III -</strong> decurso de seu prazo; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">IV -</strong> troca do equipamento já cadastrado, exceto quando relativo a sistema de segurança. </p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 67. </strong>Constatada a qualquer tempo a não veracidade das declarações apresentadas nos pedidos de que trata esta lei, aplicam-se, ao proprietário ou possuidor e profissionais envolvidos, as penalidades administrativas previstas neste Código, sem prejuízo das sanções criminais cabíveis.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 1º </strong>A atuação irregular do profissional deve ser comunicada ao órgão federal fiscalizador do exercício profissional.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 2º </strong>Caso haja elementos que indiquem a prática de infração penal, a Prefeitura comunicará o fato à autoridade policial competente.</p>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 68. </strong>Caso se tenha notícia de fato que possa ensejar a cassação ou anulação do documento expedido, nos termos dos incisos II e III do art. 63 deste Código, a Prefeitura deve notificar o interessado para a apresentação de defesa no prazo de 30 (trinta) dias, de forma a garantir o contraditório e a ampla defesa, podendo, na defesa, comprovar ter sido sanada a irregularidade.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 1º </strong>Por motivo relevante ou para evitar prejuízo de difícil reparação, a Prefeitura pode suspender os efeitos do documento emitido até decisão sobre sua anulação ou cassação.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 2º </strong>Decorrido o prazo para defesa, a Prefeitura pode efetuar as diligências cabíveis e pedir esclarecimentos a outro órgão público envolvido.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 3º </strong>No prazo de 30 (trinta) dias, a autoridade deve decidir a respeito da anulação ou cassação do documento.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 57. </strong>Caso se tenha notícia de fato que possa ensejar a cassação ou anulação de Alvará de Aprovação ou de Execução de edificação, nos termos dos incisos II e III do artigo 63 do COE, a Coordenadoria competente notificará o interessado para apresentar defesa no prazo de 30 (trinta) dias contados da data da publicação da chamada no DOC, de forma a garantir o contraditório e a ampla defesa, podendo, na defesa, comprovar ter sido sanada a irregularidade. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 1º </strong>Por motivo relevante ou para evitar prejuízo de difícil reparação, será proferido despacho suspendendo os efeitos do Alvará de Aprovação ou do Alvará de Execução de edificação até a decisão sobre sua anulação ou cassação. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 2º </strong>Decorrido o prazo para defesa, a Prefeitura poderá efetuar as diligências cabíveis e pedir esclarecimentos a outro órgão público envolvido. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 3º </strong>No prazo de 30 (trinta) dias, a autoridade deverá decidir a respeito da anulação ou cassação do Alvará de Aprovação ou do Alvará de Execução de edificação. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 4º </strong>Do despacho que anular ou cassar o alvará, caberá um único recurso no prazo de 30 (trinta) dias, contados de sua publicação no DOC, a ser apreciado pelo Secretário Municipal de Urbanismo e Licenciamento ou Prefeito Regional, no âmbito de suas respectivas competências. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 5º </strong>A decisão do recurso pelo Secretário Municipal de Urbanismo e Licenciamento ou Prefeito Regional encerra definitivamente a instância administrativa a respeito de declaração de nulidade, anulação ou cassação do alvará. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 6º </strong>As notificações e comunicações de decisões de que tratam este artigo serão publicadas no DOC e poderão ser enviadas ao interessado por meio do endereço eletrônico cadastrado no processo. </p>

		<h2>Seção II - Das Instâncias e Prazos para Despacho</h2>
		<p class="corpo_lei"><strong class="bolinha">Art. 69.</strong> As instâncias administrativas para a apreciação e decisão dos pedidos de que trata este Código, protocolados a partir da data de sua vigência, são as seguintes:</p>
		<p class="corpo_lei"><strong class="destaque-lei">I - </strong>para os pedidos de competência da <strong>Secretaria Municipal de Licenciamento</strong><sup>17</sup>:</p>

		<div id="04_capitulo-IV_b01" class="glossario-box">
			<p class="corpo_referencias1"><span class="nota">17</span> Conforme Decreto Nº 57.576, a Secretaria Municipal de Licenciamento (SEL) teve suas atribuições fundidas com a Secretaria Municipal de Desenvolvimento Urbano (SMDU), tornando-se em janeiro de 2017 a atual Secretaria Municipal de Urbanismo e Licenciamento (SMUL).</p>
		</div>
		
		<p class="corpo_lei"><strong class="destaque-lei">a)</strong> Diretor de Divisão Técnica;</p>
		<p class="corpo_lei"><strong class="destaque-lei">b)</strong> Coordenador;</p>
		<p class="corpo_lei"><strong class="destaque-lei">c)</strong> Secretário Municipal de Licenciamento;</p>
		<p class="corpo_lei"><strong class="destaque-lei">II - </strong>para os pedidos de competência das Subprefeituras:</p>
		<p class="corpo_lei"><strong class="destaque-lei">a)</strong> Supervisor Técnico de Uso do Solo e Licenciamentos;</p>
		<p class="corpo_lei"><strong class="destaque-lei">b)</strong> Coordenador de Planejamento e Desenvolvimento Urbano;</p>
		<p class="corpo_lei"><strong class="destaque-lei">c)</strong> Subprefeito.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 1º </strong>Cabe recurso à autoridade imediatamente superior àquela que proferiu a decisão.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 2º </strong>A competência para a apreciação dos pedidos e decisão em primeira instância pode ser delegada aos técnicos e chefes de seção, mediante portaria do Secretário Municipal de Licenciamento ou do Secretário Municipal de Coordenação das Subprefeituras, mantida a competência originária para a apreciação e decisão dos recursos.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 3º </strong>Os despachos do Secretário Municipal de Licenciamento e dos Subprefeitos em grau de recurso, bem como o decurso do prazo recursal encerram definitivamente a instância administrativa.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 58. </strong>As instâncias administrativas para a apreciação e decisão dos pedidos de que trata este Código, protocolados a partir da data de sua vigência, são as seguintes:<strong class="destaque-decreto"></strong></p>
		<p class="corpo_decreto"><strong class="destaque-decreto">I -</strong> para os pedidos de competência da Secretaria Municipal de Urbanismo e Licenciamento: </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">a)</strong> Diretor de Divisão Técnica; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">b)</strong> Coordenador; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">c)</strong> Secretário Municipal de Urbanismo e Licenciamento; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">II -</strong> para os pedidos de competência das Prefeituras Regionais: </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">a)</strong> Supervisor Técnico de Uso do Solo e Licenciamento; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">b)</strong> Coordenador de Planejamento e Desenvolvimento Urbano; </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">c)</strong> Prefeito Regional. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 1º </strong>Cabe recurso à autoridade imediatamente superior àquela que proferiu a decisão. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 2º </strong>A competência para a apreciação dos pedidos e decisão em primeira instância pode ser delegada aos técnicos e chefes de seção, mediante portaria do Secretário Municipal de Urbanismo e Licenciamento ou do Secretário Municipal das Prefeituras Regionais, mantida a competência originária para a apreciação e decisão dos recursos.</p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 3º </strong>Os despachos do Secretário Municipal de Urbanismo e Licenciamento e dos Prefeitos Regionais em grau de recurso, bem como o decurso do prazo recursal encerram definitivamente a instância administrativa. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 4º </strong>O recurso intempestivo será indeferido de imediato em primeira instância administrativa. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 5º </strong>No licenciamento da edificação que envolver simultaneamente o parcelamento do solo como Plano Integrado, os pedidos de loteamento, desmembramento e reparcelamento ficam sujeitos às instâncias do “caput” deste artigo.</p>

		<!-- 04_capitulo-IV_d02.html -->
		<div id="g-04_capitulo-IV_d02-box" class="ai2html">
			<div id="g-04_capitulo-IV_d02-01" class="g-artboard g-artboard-v4" data-max-width='960'>
				<img id="g-04_capitulo-IV_d02-01-img" class="g-aiImg" :src="caminho + '04_capitulo-IV_d02-01.png'"/>
				<div id="g-ai0-1" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:1.5866%;margin-top:-11.9px;left:0.1042%;width:254px;">
					<p class="g-pstyle0">INSTÂNCIAS DE APROVAÇÃO</p>
				</div>
				<div id="g-ai0-2" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:1.5761%;margin-top:-9.8px;left:92%;width:85px;">
					<p class="g-pstyle1">Lei Art. 69</p>
				</div>
				<div id="g-ai0-3" class="g-Camada_1 g-aiAbs" style="top:3.4263%;left:0.1042%;width:83.2292%;">
					<p class="g-pstyle2">As instâncias administrativas para a apreciação e decisão dos pedidos de que trata este Código foram simplificadas e operam da seguinte maneira:</p>
				</div>
				<div id="g-ai0-4" class="g-Camada_1 g-aiAbs" style="top:9.8008%;left:0.1042%;width:83.2292%;">
					<p class="g-pstyle3">COMO ERA</p>
				</div>
				<div id="g-ai0-5" class="g-Camada_1 g-aiAbs" style="top:12.749%;left:0.1042%;width:83.2292%;">
					<p class="g-pstyle2">Lei 11.228/92 &bull; Decreto 32.329/92 &bull; Anistia Lei 11.522/9424</p>
				</div>
				<div id="g-ai0-6" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:19.4515%;margin-top:-8.1px;left:5.7861%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-7" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:19.4515%;margin-top:-8.1px;left:23.6543%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-8" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:19.4515%;margin-top:-8.1px;left:41.5226%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-9" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:19.4515%;margin-top:-8.1px;left:59.3911%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-10" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:19.4515%;margin-top:-8.1px;left:77.2591%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-11" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:19.4515%;margin-top:-8.1px;left:95.1276%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-12" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:2.346%;width:101px;">
					<p class="g-pstyle5">1&ordf;<span class="g-cstyle0"> </span>ins<span class="g-cstyle1">t</span><span class="g-cstyle0">â</span>n<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-13" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:9.5747%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-14" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:20.2143%;width:101px;">
					<p class="g-pstyle7"><span class="g-cstyle3">1&ordf;</span> i<span class="g-cstyle3">ns</span><span class="g-cstyle1">t</span>â<span class="g-cstyle3">n</span>ci<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-15" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:27.4431%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-16" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:38.0522%;width:101px;">
					<p class="g-pstyle5">2&ordf;<span class="g-cstyle0"> i</span>ns<span class="g-cstyle4">t</span>ân<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-17" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:45.3417%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-18" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:55.9363%;width:101px;">
					<p class="g-pstyle7">3<span class="g-cstyle3">&ordf;</span> i<span class="g-cstyle3">ns</span><span class="g-cstyle4">t</span>â<span class="g-cstyle3">n</span>ci<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-19" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:63.1944%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-20" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:73.7838%;width:101px;">
					<p class="g-pstyle5">4&ordf;<span class="g-cstyle0"> </span>ins<span class="g-cstyle4">t</span>ân<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-21" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:81.0834%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-22" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:91.544%;width:101px;">
					<p class="g-pstyle5">5&ordf;<span class="g-cstyle0"> </span>ins<span class="g-cstyle4">t</span>ân<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-23" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:20.7283%;margin-top:-10.1px;left:98.9557%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-24" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.2135%;margin-top:-9.8px;left:0.7654%;width:137px;">
					<p class="g-pstyle8"><span class="g-cstyle5">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">or</span> <span class="g-cstyle0">d</span>e <span class="g-cstyle0">d</span><span class="g-cstyle7">i</span>visã<span class="g-cstyle2">o </span></p>
				</div>
				<div id="g-ai0-25" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.2135%;margin-top:-9.8px;left:18.6338%;width:137px;">
					<p class="g-pstyle8"><span class="g-cstyle8">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">o</span>r <span class="g-cstyle0">d</span>e d<span class="g-cstyle7">i</span>visã<span class="g-cstyle2">o </span></p>
				</div>
				<div id="g-ai0-26" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.2135%;margin-top:-9.8px;left:36.4558%;width:136px;">
					<p class="g-pstyle8"><span class="g-cstyle8">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">or</span> de dep<span class="g-cstyle2">t</span><span class="g-cstyle0">o</span> <span class="g-cstyle2">/ </span></p>
				</div>
				<div id="g-ai0-27" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.2135%;margin-top:-9.8px;left:47.0986%;width:26px;">
					<p class="g-pstyle1"> </p>
				</div>
				<div id="g-ai0-28" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.2135%;margin-top:-9.8px;left:56.2197%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle9">S</span>e<span class="g-cstyle0">c</span><span class="g-cstyle6">r</span>e<span class="g-cstyle10">t</span>á<span class="g-cstyle0">r</span>io <span class="g-cstyle2">/ </span></p>
				</div>
				<div id="g-ai0-29" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.2135%;margin-top:-9.8px;left:75.33%;width:72px;">
					<p class="g-pstyle8">CEUS<span class="g-cstyle2">O</span></p>
				</div>
				<div id="g-ai0-30" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.2135%;margin-top:-9.8px;left:93.0475%;width:71px;">
					<p class="g-pstyle8"><span class="g-cstyle0">P</span><span class="g-cstyle6">r</span>e<span class="g-cstyle11">f</span>ei<span class="g-cstyle2">to</span></p>
				</div>
				<div id="g-ai0-31" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:23.5681%;margin-top:-9.8px;left:2.457%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle0">/</span> <span class="g-cstyle9">S</span><span class="g-cstyle0">u</span>pe<span class="g-cstyle12">r</span>vis<span class="g-cstyle0">o</span><span class="g-cstyle2">r</span></p>
				</div>
				<div id="g-ai0-32" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:23.5681%;margin-top:-9.8px;left:20.3253%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle0">/</span> <span class="g-cstyle9">S</span>upe<span class="g-cstyle13">r</span>viso<span class="g-cstyle2">r</span></p>
				</div>
				<div id="g-ai0-33" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:23.5681%;margin-top:-9.8px;left:36.3151%;width:138px;">
					<p class="g-pstyle8">Che<span class="g-cstyle11">f</span>e <span class="g-cstyle0">d</span>e <span class="g-cstyle0">g</span>a<span class="g-cstyle0">b</span>ine<span class="g-cstyle2">te</span></p>
				</div>
				<div id="g-ai0-34" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:23.5681%;margin-top:-9.8px;left:56.2018%;width:94px;">
					<p class="g-pstyle8"><span class="g-cstyle9">S</span>u<span class="g-cstyle0">b</span>p<span class="g-cstyle6">r</span>e<span class="g-cstyle11">f</span>ei<span class="g-cstyle2">to</span></p>
				</div>
				<div id="g-ai0-35" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:27.8302%;margin-top:-18.3px;left:25.001%;margin-left:-78.5px;width:157px;">
					<p class="g-pstyle9">RECONSIDERAÇÃO</p>
					<p class="g-pstyle9">DE DESPACHO</p>
				</div>
				<div id="g-ai0-36" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:27.7912%;margin-top:-9.8px;left:8.2011%;margin-left:-65.5px;width:131px;">
					<p class="g-pstyle9">PEDIDO INICIAL</p>
				</div>
				<div id="g-ai0-37" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:27.7912%;margin-top:-9.8px;left:63.9142%;width:93px;">
					<p class="g-pstyle8">RECURS<span class="g-cstyle2">O</span></p>
				</div>
				<div id="g-ai0-38" class="g-Camada_1 g-aiAbs" style="top:33.1474%;left:0.1042%;width:83.2292%;">
					<p class="g-pstyle2">Anistia Lei 13.558/03 &bull; Anistia Lei 13.876/04 &bull; Anistia Decreto 45.324/04</p>
				</div>
				<div id="g-ai0-39" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:40.1686%;margin-top:-8.1px;left:5.7861%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-40" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:40.1686%;margin-top:-8.1px;left:23.6543%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-41" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:40.1686%;margin-top:-8.1px;left:41.5226%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-42" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:40.1686%;margin-top:-8.1px;left:41.5289%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-43" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:41.4455%;margin-top:-10.1px;left:2.346%;width:101px;">
					<p class="g-pstyle5">1&ordf;<span class="g-cstyle0"> </span>ins<span class="g-cstyle1">t</span><span class="g-cstyle0">â</span>n<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-44" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:41.4455%;margin-top:-10.1px;left:9.5747%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-45" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:41.4455%;margin-top:-10.1px;left:19.7375%;width:101px;">
					<p class="g-pstyle5">2&ordf;<span class="g-cstyle0"> i</span>ns<span class="g-cstyle4">t</span>ân<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-46" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:41.4455%;margin-top:-10.1px;left:27.4431%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-47" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:41.4455%;margin-top:-10.1px;left:37.585%;width:101px;">
					<p class="g-pstyle7">3<span class="g-cstyle3">&ordf;</span> i<span class="g-cstyle3">ns</span><span class="g-cstyle4">t</span>â<span class="g-cstyle3">n</span>ci<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-48" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:41.4455%;margin-top:-10.1px;left:45.3417%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-49" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:41.4455%;margin-top:-10.1px;left:55.4506%;width:101px;">
					<p class="g-pstyle5">4&ordf;<span class="g-cstyle0"> </span>ins<span class="g-cstyle4">t</span>ân<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-50" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:42.851%;margin-top:-9.8px;left:0.7654%;width:137px;">
					<p class="g-pstyle8"><span class="g-cstyle5">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">or</span> <span class="g-cstyle0">d</span>e <span class="g-cstyle0">d</span><span class="g-cstyle7">i</span>visã<span class="g-cstyle2">o </span></p>
				</div>
				<div id="g-ai0-51" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:42.851%;margin-top:-9.8px;left:17.9166%;width:136px;">
					<p class="g-pstyle8"><span class="g-cstyle8">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">or</span> de dep<span class="g-cstyle2">t</span><span class="g-cstyle0">o</span> <span class="g-cstyle2">/ </span></p>
				</div>
				<div id="g-ai0-52" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:42.851%;margin-top:-9.8px;left:47.0986%;width:26px;">
					<p class="g-pstyle1"> </p>
				</div>
				<div id="g-ai0-53" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:42.9307%;margin-top:-9.8px;left:37.7024%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle9">S</span>e<span class="g-cstyle0">c</span><span class="g-cstyle6">r</span>e<span class="g-cstyle10">t</span>á<span class="g-cstyle0">r</span>io <span class="g-cstyle2">/ </span></p>
				</div>
				<div id="g-ai0-54" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:42.9307%;margin-top:-9.8px;left:57.0392%;width:71px;">
					<p class="g-pstyle8"><span class="g-cstyle0">P</span><span class="g-cstyle6">r</span>e<span class="g-cstyle11">f</span>ei<span class="g-cstyle2">to</span></p>
				</div>
				<div id="g-ai0-55" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:44.2853%;margin-top:-9.8px;left:2.457%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle0">/</span> <span class="g-cstyle9">S</span><span class="g-cstyle0">u</span>pe<span class="g-cstyle12">r</span>vis<span class="g-cstyle0">o</span><span class="g-cstyle2">r</span></p>
				</div>
				<div id="g-ai0-56" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:44.2853%;margin-top:-9.8px;left:37.9287%;width:94px;">
					<p class="g-pstyle8"><span class="g-cstyle9">S</span>u<span class="g-cstyle0">b</span>p<span class="g-cstyle6">r</span>e<span class="g-cstyle11">f</span>ei<span class="g-cstyle2">to</span></p>
				</div>
				<div id="g-ai0-57" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:44.2852%;margin-top:-9.8px;left:17.8007%;width:138px;">
					<p class="g-pstyle8">Che<span class="g-cstyle11">f</span>e <span class="g-cstyle0">d</span>e <span class="g-cstyle0">g</span>a<span class="g-cstyle0">b</span>ine<span class="g-cstyle2">te</span></p>
				</div>
				<div id="g-ai0-58" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:48.5083%;margin-top:-9.8px;left:8.2011%;margin-left:-65.5px;width:131px;">
					<p class="g-pstyle9">PEDIDO INICIAL</p>
				</div>
				<div id="g-ai0-59" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:48.5083%;margin-top:-9.8px;left:37.5692%;width:93px;">
					<p class="g-pstyle8">RECURS<span class="g-cstyle2">O</span></p>
				</div>
				<div id="g-ai0-60" class="g-Camada_1 g-aiAbs" style="top:54.6614%;left:0.1042%;width:83.2292%;">
					<p class="g-pstyle2">Lei 11.228/92 &bull; Lei 15.764/13 &bull; Decreto 54.213/13</p>
				</div>
				<div id="g-ai0-61" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:61.3638%;margin-top:-8.1px;left:5.7861%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-62" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:61.3638%;margin-top:-8.1px;left:23.6543%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-63" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:61.3638%;margin-top:-8.1px;left:41.5226%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-64" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:61.3638%;margin-top:-8.1px;left:59.3911%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-65" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:61.3638%;margin-top:-8.1px;left:77.2591%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-66" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:2.346%;width:101px;">
					<p class="g-pstyle5">1&ordf;<span class="g-cstyle0"> </span>ins<span class="g-cstyle1">t</span><span class="g-cstyle0">â</span>n<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-67" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:9.5747%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-68" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:20.2143%;width:101px;">
					<p class="g-pstyle7"><span class="g-cstyle3">1&ordf;</span> i<span class="g-cstyle3">ns</span><span class="g-cstyle1">t</span>â<span class="g-cstyle3">n</span>ci<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-69" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:27.4431%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-70" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:38.0522%;width:101px;">
					<p class="g-pstyle5">2&ordf;<span class="g-cstyle0"> i</span>ns<span class="g-cstyle4">t</span>ân<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-71" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:45.3417%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-72" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:55.9363%;width:101px;">
					<p class="g-pstyle7">3<span class="g-cstyle3">&ordf;</span> i<span class="g-cstyle3">ns</span><span class="g-cstyle4">t</span>â<span class="g-cstyle3">n</span>ci<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-73" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:63.1944%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-74" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:62.6407%;margin-top:-10.1px;left:73.7838%;width:101px;">
					<p class="g-pstyle5">4&ordf;<span class="g-cstyle0"> </span>ins<span class="g-cstyle4">t</span>ân<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-75" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:64.0462%;margin-top:-9.8px;left:0.7654%;width:137px;">
					<p class="g-pstyle8"><span class="g-cstyle5">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">or</span> <span class="g-cstyle0">d</span>e <span class="g-cstyle0">d</span><span class="g-cstyle7">i</span>visã<span class="g-cstyle2">o </span></p>
				</div>
				<div id="g-ai0-76" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:64.0462%;margin-top:-9.8px;left:18.6338%;width:137px;">
					<p class="g-pstyle8"><span class="g-cstyle8">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">o</span>r <span class="g-cstyle0">d</span>e d<span class="g-cstyle7">i</span>visã<span class="g-cstyle2">o </span></p>
				</div>
				<div id="g-ai0-77" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:64.0462%;margin-top:-9.8px;left:36.4558%;width:136px;">
					<p class="g-pstyle8"><span class="g-cstyle8">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">or</span> de dep<span class="g-cstyle2">t</span><span class="g-cstyle0">o</span> <span class="g-cstyle2">/ </span></p>
				</div>
				<div id="g-ai0-78" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:64.0462%;margin-top:-9.8px;left:47.0986%;width:26px;">
					<p class="g-pstyle1"> </p>
				</div>
				<div id="g-ai0-79" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:64.0462%;margin-top:-9.8px;left:56.2197%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle9">S</span>e<span class="g-cstyle0">c</span><span class="g-cstyle6">r</span>e<span class="g-cstyle10">t</span>á<span class="g-cstyle0">r</span>io <span class="g-cstyle2">/ </span></p>
				</div>
				<div id="g-ai0-80" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:64.0462%;margin-top:-9.8px;left:75.33%;width:71px;">
					<p class="g-pstyle8">Prefeito</p>
				</div>
				<div id="g-ai0-81" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:65.4805%;margin-top:-9.8px;left:2.457%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle0">/</span> <span class="g-cstyle9">S</span><span class="g-cstyle0">u</span>pe<span class="g-cstyle12">r</span>vis<span class="g-cstyle0">o</span><span class="g-cstyle2">r</span></p>
				</div>
				<div id="g-ai0-82" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:65.4805%;margin-top:-9.8px;left:20.3253%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle0">/</span> <span class="g-cstyle9">S</span>upe<span class="g-cstyle13">r</span>viso<span class="g-cstyle2">r</span></p>
				</div>
				<div id="g-ai0-83" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:65.4805%;margin-top:-9.8px;left:36.3151%;width:138px;">
					<p class="g-pstyle8">Che<span class="g-cstyle11">f</span>e <span class="g-cstyle0">d</span>e <span class="g-cstyle0">g</span>a<span class="g-cstyle0">b</span>ine<span class="g-cstyle2">te</span></p>
				</div>
				<div id="g-ai0-84" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:65.4805%;margin-top:-9.8px;left:56.2018%;width:94px;">
					<p class="g-pstyle8"><span class="g-cstyle9">S</span>u<span class="g-cstyle0">b</span>p<span class="g-cstyle6">r</span>e<span class="g-cstyle11">f</span>ei<span class="g-cstyle2">to</span></p>
				</div>
				<div id="g-ai0-85" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:69.7426%;margin-top:-18.3px;left:25.001%;margin-left:-78.5px;width:157px;">
					<p class="g-pstyle9">RECONSIDERAÇÃO</p>
					<p class="g-pstyle9">DE DESPACHO</p>
				</div>
				<div id="g-ai0-86" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:69.7832%;margin-top:-9.8px;left:54.6545%;width:93px;">
					<p class="g-pstyle8">RECURS<span class="g-cstyle2">O</span></p>
				</div>
				<div id="g-ai0-87" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:69.7832%;margin-top:-9.8px;left:8.2011%;margin-left:-65.5px;width:131px;">
					<p class="g-pstyle9">PEDIDO INICIAL</p>
				</div>
				<div id="g-ai0-88" class="g-Camada_1 g-aiAbs" style="top:77.2908%;left:0.1042%;width:83.2292%;">
					<p class="g-pstyle3">COMO FICOU</p>
				</div>
				<div id="g-ai0-89" class="g-Camada_1 g-aiAbs" style="top:80.239%;left:0.1042%;width:83.2292%;">
					<p class="g-pstyle2">Lei 16.642/17 &bull; Decreto 57.776/17</p>
				</div>
				<div id="g-ai0-90" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:86.7024%;margin-top:-8.1px;left:5.7861%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-91" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:86.7024%;margin-top:-8.1px;left:23.6543%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-92" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:86.7024%;margin-top:-8.1px;left:41.5226%;width:25px;">
					<p class="g-pstyle4"> </p>
				</div>
				<div id="g-ai0-93" class="g-Camada_1 g-aiAbs g-aiPointText" style="transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);transform-origin: 50% 54.9306625577812%;-webkit-transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);-webkit-transform-origin: 50% 54.9306625577812%;-ms-transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);-ms-transform-origin: 50% 54.9306625577812%;top:87.9793%;margin-top:-10.1px;left:41.7239%;margin-left:-50.5px;width:101px;">
					<p class="g-pstyle10">3&ordf;<span class="g-cstyle0"> i</span>ns<span class="g-cstyle4">t</span>ân<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-94" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:87.9793%;margin-top:-10.1px;left:2.346%;width:101px;">
					<p class="g-pstyle5">1&ordf;<span class="g-cstyle0"> </span>ins<span class="g-cstyle1">t</span><span class="g-cstyle0">â</span>n<span class="g-cstyle0">c</span>i<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-95" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:87.9793%;margin-top:-10.1px;left:9.5747%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-96" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:87.9793%;margin-top:-10.1px;left:20.2143%;width:101px;">
					<p class="g-pstyle7"><span class="g-cstyle3">2&ordf;</span> i<span class="g-cstyle3">ns</span><span class="g-cstyle1">t</span>â<span class="g-cstyle3">n</span>ci<span class="g-cstyle2">a</span></p>
				</div>
				<div id="g-ai0-97" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:87.9793%;margin-top:-10.1px;left:27.4431%;width:26px;">
					<p class="g-pstyle6"> </p>
				</div>
				<div id="g-ai0-98" class="g-Camada_1 g-aiAbs g-aiPointText" style="transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);transform-origin: 50% 55.1125867492136%;-webkit-transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);-webkit-transform-origin: 50% 55.1125867492136%;-ms-transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);-ms-transform-origin: 50% 55.1125867492136%;top:89.3848%;margin-top:-9.8px;left:41.7137%;margin-left:-44px;width:88px;">
					<p class="g-pstyle11">Secretário</p>
				</div>
				<div id="g-ai0-99" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:89.3848%;margin-top:-9.8px;left:0.7654%;width:137px;">
					<p class="g-pstyle8"><span class="g-cstyle5">D</span>i<span class="g-cstyle6">r</span>e<span class="g-cstyle2">t</span><span class="g-cstyle0">or</span> <span class="g-cstyle0">d</span>e <span class="g-cstyle0">d</span><span class="g-cstyle7">i</span>visã<span class="g-cstyle2">o </span></p>
				</div>
				<div id="g-ai0-100" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:89.3848%;margin-top:-9.8px;left:19.9347%;width:106px;">
					<p class="g-pstyle12">Coordenador</p>
				</div>
				<div id="g-ai0-101" class="g-Camada_1 g-aiAbs g-aiPointText" style="transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);transform-origin: 50% 55.1123315027459%;-webkit-transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);-webkit-transform-origin: 50% 55.1123315027459%;-ms-transform: matrix(0.9998,-0.0196,0.0196,0.9998,0,0);-ms-transform-origin: 50% 55.1123315027459%;top:90.8191%;margin-top:-9.8px;left:41.7317%;margin-left:-70px;width:140px;">
					<p class="g-pstyle9">/ Prefeito Regional</p>
				</div>
				<div id="g-ai0-102" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:90.8191%;margin-top:-9.8px;left:2.457%;width:99px;">
					<p class="g-pstyle8"><span class="g-cstyle0">/</span> <span class="g-cstyle9">S</span><span class="g-cstyle0">u</span>pe<span class="g-cstyle12">r</span>vis<span class="g-cstyle0">o</span><span class="g-cstyle2">r</span></p>
				</div>
				<div id="g-ai0-103" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:90.8191%;margin-top:-9.8px;left:18.2846%;width:138px;">
					<p class="g-pstyle13"><span class="g-cstyle0">/</span><span class="g-cstyle3"> </span>Coord. de CPDU</p>
				</div>
				<div id="g-ai0-104" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:95.2015%;margin-top:-9.8px;left:29.4898%;width:93px;">
					<p class="g-pstyle8">RECURS<span class="g-cstyle2">O</span></p>
				</div>
				<div id="g-ai0-105" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:95.2016%;margin-top:-9.8px;left:8.2011%;margin-left:-65.5px;width:131px;">
					<p class="g-pstyle9">PEDIDO INICIAL</p>
				</div>
			</div>
		</div>

		<p class="corpo_lei"><strong class="bolinha">Art. 70.</strong> O prazo para a decisão dos pedidos não pode exceder 90 (noventa) dias, inclusive quando se tratar de recurso.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 1º </strong>Prazos diferentes podem ser fixados por ato do Executivo, em função da complexidade da análise do pedido.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 2º </strong>O curso do prazo fixado no “caput” deste artigo fica suspenso durante a pendência do atendimento, pelo interessado, das exigências feitas no “comunique-se”.</p>
		<p class="corpo_lei"><strong class="bolinha">Art. 71.</strong> Escoado o prazo para a decisão do processo de Alvará de Aprovação, o interessado pode requerer o Alvará de Execução.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 1º </strong>Decorridos 30 (trinta) dias contados da data do protocolo do pedido do Alvará de Execução, caso o processo não tenha sido indeferido, a obra pode ser iniciada, sendo de inteira responsabilidade do proprietário ou possuidor e profissionais envolvidos a adequação da obra às posturas municipais.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 2º </strong>Quando solicitado Alvará de Aprovação e de Execução em conjunto, o prazo para a decisão é de 120 (cento e vinte) dias.</p>
		<p class="corpo_lei"><strong class="destaque-lei">§ 3º </strong>Nos casos de incidência de outorga onerosa, o início da obra fica condicionado à comprovação de seu pagamento.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 59. </strong>O direito do início de obras se dará após 30 (trinta) dias do protocolo do pedido de Alvará de Execução ou 120 (cento e vinte) dias do protocolo do pedido de Alvará de Aprovação e Execução, exceto quando:</p>
		<p class="corpo_decreto"><strong class="destaque-decreto">I -</strong> indeferido o pedido;</p>
		<p class="corpo_decreto"><strong class="destaque-decreto">II -</strong> incidir outorga onerosa.</p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 1º </strong>A contagem dos prazos previstos no “caput” deste artigo fica suspensa durante transcurso do prazo de atendimento de “comunique-se”.</p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 2º </strong>Para os fins do “caput” deste artigo, será considerada início das obras qualquer intervenção para a execução das obras relacionadas no artigo 23 do COE.</p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 3º </strong>Será de inteira responsabilidade do proprietário ou possuidor e profissionais habilitados a eventual necessidade de adequação da obra às posturas municipais.</p>

		<!-- 04_capitulo-IV_d03.html -->
		<div id="g-04_capitulo-IV_d03-box" class="ai2html">
			<div id="g-04_capitulo-IV_d03-01" class="g-artboard g-artboard-v4" data-max-width='960'>
				<img id="g-04_capitulo-IV_d03-01-img" class="g-aiImg" :src="caminho + '04_capitulo-IV_d03-01.png'"/>
				<div id="g-ai0-1" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:1.5085%;margin-top:-11.9px;left:0.1042%;width:194px;">
					<p class="g-pstyle0">ANÁLISE DE PEDIDOS</p>
				</div>
				<div id="g-ai0-2" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:1.4973%;margin-top:-9.8px;left:89.8077%;width:116px;">
					<p class="g-pstyle1">Lei Art. 70 e 71</p>
				</div>
				<div id="g-ai0-3" class="g-Camada_1 g-aiAbs" style="top:3.3307%;left:0.1042%;width:83.2292%;">
					<p class="g-pstyle2">O p<span class="g-cstyle0">r</span>a<span class="g-cstyle1">z</span>o <span class="g-cstyle2">p</span>a<span class="g-cstyle0">r</span>a a decisão dos pedidos em ge<span class="g-cstyle0">r</span>al é de <span class="g-cstyle2">9</span>0 dias, podendo ser ﬁxados p<span class="g-cstyle0">r</span>a<span class="g-cstyle1">z</span>os di<span class="g-cstyle3">f</span>e<span class="g-cstyle4">r</span>en<span class="g-cstyle1">t</span>es por a<span class="g-cstyle1">t</span>o do Execut<span class="g-cstyle2">i</span><span class="g-cstyle1">v</span>o em função da com<span class="g-cstyle5">p</span>lexidade da análise do pedid<span class="g-cstyle6">o</span>. <span class="g-cstyle2">N</span>o caso de pedido de Al<span class="g-cstyle2">v</span>a<span class="g-cstyle0">r</span>á de Ap<span class="g-cstyle4">r</span><span class="g-cstyle7">o</span><span class="g-cstyle2">v</span>açã<span class="g-cstyle8">o</span>, deco<span class="g-cstyle9">r</span>rido esse períod<span class="g-cstyle8">o</span>, pode<span class="g-cstyle10">r</span>á ser <span class="g-cstyle4">r</span>equerido o Al<span class="g-cstyle2">v</span>a<span class="g-cstyle0">r</span>á de Execuçã<span class="g-cstyle6">o</span>, que de<span class="g-cstyle1">v</span>e<span class="g-cstyle10">r</span>á <span class="g-cstyle1">t</span>er decisão em 30 dias. <span class="g-cstyle11">Q</span>uando se t<span class="g-cstyle0">r</span>a<span class="g-cstyle12">t</span>ar de pedido conjun<span class="g-cstyle1">t</span>o de Al<span class="g-cstyle2">v</span>a<span class="g-cstyle0">r</span>á de Ap<span class="g-cstyle13">r</span><span class="g-cstyle1">o</span><span class="g-cstyle2">v</span>ação e Execuçã<span class="g-cstyle6">o</span>, o p<span class="g-cstyle0">r</span>a<span class="g-cstyle7">z</span>o <span class="g-cstyle2">p</span>a<span class="g-cstyle0">r</span>a decisão é de 1<span class="g-cstyle14">2</span>0 dias.</p>
				</div>
				<div id="g-ai0-4" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.842%;margin-top:-11.8px;left:9.2308%;width:114px;">
					<p class="g-pstyle3"><span class="g-cstyle1">A</span>U<span class="g-cstyle15">T</span><span class="g-cstyle1">U</span><span class="g-cstyle16">A</span>Ç<span class="g-cstyle17">Ã</span><span class="g-cstyle18">O</span></p>
				</div>
				<div id="g-ai0-5" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.8135%;margin-top:-11.4px;left:42.8305%;width:162px;">
					<p class="g-pstyle4">&ldquo;COMUNIQUE-SE&rdquo;</p>
				</div>
				<div id="g-ai0-6" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:22.8135%;margin-top:-11.4px;left:86.5437%;margin-left:-101px;width:202px;">
					<p class="g-pstyle5">REPOSTAS AO PEDIDO</p>
				</div>
				<div id="g-ai0-7" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:24.599%;margin-top:-11px;left:5.3259%;width:189px;">
					<p class="g-pstyle6"><span class="g-cstyle1">P</span>edi<span class="g-cstyle15">do</span> é e<span class="g-cstyle19">n</span>viad<span class="g-cstyle15">o</span> <span class="g-cstyle20">p</span>a<span class="g-cstyle21">r</span><span class="g-cstyle18">a </span></p>
				</div>
				<div id="g-ai0-8" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:24.599%;margin-top:-11px;left:38.4322%;width:247px;">
					<p class="g-pstyle6"><span class="g-cstyle22">D</span><span class="g-cstyle15">u</span><span class="g-cstyle21">r</span>an<span class="g-cstyle18">t</span>e <span class="g-cstyle15">o</span> p<span class="g-cstyle7">r</span><span class="g-cstyle15">o</span>cess<span class="g-cstyle16">o</span>, P<span class="g-cstyle1">r</span>e<span class="g-cstyle8">f</span>eitu<span class="g-cstyle3">r</span><span class="g-cstyle18">a </span></p>
				</div>
				<div id="g-ai0-9" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:24.599%;margin-top:-11px;left:86.5483%;margin-left:-107.5px;width:215px;">
					<p class="g-pstyle7">Documentação deferida ou </p>
				</div>
				<div id="g-ai0-10" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:26.113%;margin-top:-11px;left:6.4242%;width:168px;">
					<p class="g-pstyle6">aná<span class="g-cstyle15">l</span>ise e ap<span class="g-cstyle1">r</span><span class="g-cstyle18">o</span><span class="g-cstyle23">v</span>açã<span class="g-cstyle18">o</span></p>
				</div>
				<div id="g-ai0-11" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:26.113%;margin-top:-11px;left:40.8868%;width:200px;">
					<p class="g-pstyle6">p<span class="g-cstyle15">od</span>e e<span class="g-cstyle15">m</span>iti<span class="g-cstyle15">r</span> <span class="g-cstyle15">co</span>m<span class="g-cstyle15">u</span>ni<span class="g-cstyle15">c</span>a<span class="g-cstyle15">d</span><span class="g-cstyle18">o </span></p>
				</div>
				<div id="g-ai0-12" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:26.113%;margin-top:-11px;left:86.5289%;margin-left:-102.5px;width:205px;">
					<p class="g-pstyle8">indeferida pela Prefeitura</p>
				</div>
				<div id="g-ai0-13" class="g-Camada_1 g-aiAbs" style="top:34.2155%;left:86.0556%;margin-left:-115.5px;width:24.0625%;">
					<p class="g-pstyle9">Decorrido o prazo de análise do pedido inicial + tempo de resposta ao &ldquo;comunique-se&rdquo;:</p>
				</div>
				<div id="g-ai0-14" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:37.4782%;margin-top:-6.1px;left:85.9223%;width:25px;">
					<p class="g-pstyle10"> </p>
				</div>
				<div id="g-ai0-15" class="g-Camada_1 g-aiAbs" style="top:39.363%;left:12.1615%;margin-left:-102.5px;width:21.3542%;">
					<p class="g-pstyle11">A Prefeitura tem <span class="g-cstyle24">90 dias</span> para analisar e deferir pedidos em geral, como Alvará de Aprovação.</p>
				</div>
				<div id="g-ai0-16" class="g-Camada_1 g-aiAbs" style="top:46.0244%;left:86.0527%;margin-left:-101.5px;width:21.1458%;">
					<p class="g-pstyle11">No caso de pedido de Alvará de Aprovação, poderá ser requerido o Alvará de Execução</p>
				</div>
				<div id="g-ai0-17" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:47.7505%;margin-top:-7.8px;left:85.8766%;width:25px;">
					<p class="g-pstyle12"> </p>
				</div>
				<div id="g-ai0-18" class="g-Camada_1 g-aiAbs" style="top:49.0523%;left:49.9302%;margin-left:-102.5px;width:21.3542%;">
					<p class="g-pstyle11">A contagem dos prazos de análise fica suspensa durante o período de atendimento ao &ldquo;COMUNIQUE-SE&rdquo;</p>
				</div>
				<div id="g-ai0-19" class="g-Camada_1 g-aiAbs" style="top:55.1081%;left:12.1615%;margin-left:-102.5px;width:21.3542%;">
					<p class="g-pstyle11">A Prefeitura tem <span class="g-cstyle24">30 dias</span> para analisar e deferir pedidos em geral, como Alvará de Execução e 120 dias para analisar e deferir pedidos de Alvará de Aprovação e Execução em protocolo único.</p>
				</div>
				<div id="g-ai0-20" class="g-Camada_1 g-aiAbs" style="top:60.8612%;left:86.0527%;margin-left:-101.5px;width:21.1458%;">
					<p class="g-pstyle11">No caso de pedido de Alvará de Execução, dá-se o direito ao <span class="g-cstyle24">início de obras</span>.*</p>
				</div>
				<div id="g-ai0-21" class="g-Camada_1 g-aiAbs g-aiPointText" style="top:61.8303%;margin-top:-7.8px;left:85.8766%;width:25px;">
					<p class="g-pstyle12"> </p>
				</div>
				<div id="g-ai0-22" class="g-Camada_1 g-aiAbs" style="top:68.8095%;left:72.6043%;width:26.7708%;">
					<p class="g-pstyle13">* A obra poderá ter início, sendo de inteira responsabilidade do proprietário ou possuidor e profissionais envolvidos a adequação da obra às posturas municipais</p>
				</div>
				<div id="g-ai0-23" class="g-Camada_1 g-aiAbs g-aiPointText" style="top: 82.0511%; margin-top: -11.9px; left:0; width:100%;">
					<p class="g-pstyle3" style="margin: 15px 0;">ACOMPANHAMENTO DOS PEDIDOS EM ANÁLISE</p>
					<p style="margin: 15px 0;"><strong>SIMPROC:</strong> Com o número do processo é possível consultar o seu andamento, onde ele se encontra e todo o histórico.<br>
						Disponível em: <a href="http://simprocservicos.prefeitura.sp.gov.br/Forms/DadosCadastrais.aspx" target="_blank">http://simprocservicos.prefeitura.sp.gov.br/Forms/DadosCadastrais.aspx</a>.</p>
					<p style="margin: 15px 0;"><strong>De olho na obra:</strong> Através do endereço ou do SQL é possível consultar todos os documentos concedido a um empreendimento.<br>
						Disponível em: <a href="https://www3.prefeitura.sp.gov.br/deolhonaobra/forms/frmConsultaSlc.aspx" target="_blank">https://www3.prefeitura.sp.gov.br/deolhonaobra/forms/frmConsultaSlc.aspx</a>.</p>
				</div>
			</div>
		</div>

		<h2>Seção III - Dos Procedimentos Especiais</h2>
		<p class="corpo_lei"><strong class="artigo-lei">Art. 72. </strong>O Executivo regulamentará, no prazo de 90 (noventa) dias, os procedimentos, exigências e prazos diferenciados para exame de pedidos relativos ao licenciamento de:</p>
		<p class="corpo_lei"><strong class="destaque-lei">I - </strong>empreendimento da Administração Pública Direta e Indireta;</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 60. </strong>Nos processos de interesse de órgãos ou de serviços públicos, em especial aqueles da Administração Pública Direta e Indireta, comunicados ao interessado, inclusive sobre eventuais desconformidades em relação às normas municipais, serão feitas também mediante ofício, adotando-se o mesmo procedimento para as decisões. </p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 61. </strong>Nos pedidos de licenciamento edilício em imóvel de propriedade da União, do Estado e do Município protocolados até a data de entrada em vigor deste decreto e sem despacho decisório, deverá ser emitido “comunique-se” informando sobre a possibilidade de opção pelo encerramento do processo nos termos do artigo 14 do COE. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 1º </strong>Nos processos em andamento de que trata o “caput” deste artigo, quando o pedido incluir a regularização de edificação declarada existente até 31 de julho de 2014, data da Lei nº 16.050, de 31 de julho de 2014, também deverá ser dada ciência ao interessado quanto às disposições do artigo 109 do COE. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 2º </strong>Em caso de desistência do pedido, deve ser exarado despacho declaratório de indeferimento na instância alcançada, sem a emissão de documento. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">§ 3º </strong>O disposto neste artigo não dispensa da necessidade de elaboração de projeto ou verificação da edificação por profissional habilitado e não desobriga o profissional do cumprimento das normas disciplinadoras de sua regular atuação e daquelas decorrentes da legislação federal, estadual e municipal, bem como não desobriga o proprietário e o responsável técnico do atendimento às disposições da LPUOS e da LOE, em especial do atendimento às normas de estabilidade, segurança, salubridade e acessibilidade da edificação. </p>
		<p class="corpo_lei"><strong class="destaque-lei">II - </strong>Empreendimento Habitacional de Interesse Social em ZEIS – EZEIS, Empreendimento Habitacional de Interesse Social – EHIS, Empreendimento Habitacional do Mercado Popular – EHMP, Habitação de Interesse Social – HIS, Habitação de Mercado Popular – HMP e moradia econômica, definidos em legislação específica;</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 62. </strong>Os Empreendimentos Habitacionais de Interesse Social em ZEIS – EZEIS, Empreendimentos Habitacionais de Interesse Social – EHIS, Empreendimentos Habitacionais do Mercado Popular – EHMP, Habitação de Interesse Social – HIS, Habitação de Mercado Popular – HMP e moradia econômica são regulamentados pelo Decreto nº 57.377, de 11 de outubro de 2016, e posteriores alterações. </p>
		<p class="corpo_decreto"><strong class="destaque-decreto">Parágrafo único. </strong>A edificação destinada aos empreendimentos de que trata o “caput” deste artigo, quando executada sob a titularidade de pessoa jurídica de direito público do Município, do Estado de São Paulo e da União Federal, ainda que transferida posteriormente a terceiros, fica considerada regular na situação existente em 31 de julho de 2014, data de publicação da Lei n.º 16.050, de 2014, sendo de inteira responsabilidade do ente público executor o atendimento às normas de estabilidade, segurança, salubridade e acessibilidade, até a formalização da transferência de titularidade. </p>
		<p class="corpo_lei"><strong class="destaque-lei">III - </strong>polo gerador de tráfego;</p>
		<p class="corpo_lei"><strong class="destaque-lei">IV - </strong><strong>empreendimento gerador de impacto ambiental</strong><sup>18</sup>;</p>
		<p class="corpo_lei"><strong class="destaque-lei">V - </strong><strong>empreendimento gerador de impacto de vizinhança</strong><sup>19</sup>;</p>
		<p class="corpo_lei"><strong class="destaque-lei">VI - </strong>empreendimento com alto potencial de risco de incêndios e situações de emergência;</p>
		<p class="corpo_lei"><strong class="destaque-lei">VII - </strong><strong>empreendimento que envolva usos especiais ou incômodos</strong><sup>20</sup>;</p>

		<div class="glossario-box">
			<p><span class="nota">18</span> Empreendimento gerador de impacto ambiental – EGIA São aqueles que podem causar alteração das propriedades físicas, químicas e biológicas do meio ambiente e que direta ou indiretamente afetem: a saúde, a segurança e o bem estar da população; as atividades sociais e econômicas; a biota; as condições paisagísticas e sanitárias do meio ambiente; a qualidade dos recursos ambientais.<br>
			<span style="font-size: x-small; margin-left: 2em;">Fonte: Art. 108 da Lei nº 16.402/16</span></p>
			<p><span class="nota">19</span> Empreendimento gerador de impacto de vizinhança – EGIV São aqueles que podem gerar impacto significativo, alteração no seu entorno ou sobrecarga na capacidade de atendimento da infraestrutura do sistema viário e de transporte.<br>
			<span style="font-size: x-small; margin-left: 2em;">Fonte: Art. 108 da Lei nº 16.402/16</span></p>
			<p><span class="nota">20</span> Empreendimento que envolva usos especiais ou incômodos Enquadrados como nR3 pelo inciso IV do Art. 96 da Lei nº 16.402/16.</p>
		</div>
		
		<p class="corpo_lei"><strong class="destaque-lei">VIII - </strong>residência unifamiliar, serviços, obras e empreendimentos que, por sua natureza, admitam procedimentos simplificados.</p>
		<p class="corpo_lei"><strong class="destaque-lei">Parágrafo único. </strong>No licenciamento de residência unifamiliar pode ser emitido um único documento que englobe os alvarás de aprovação e execução.</p>
		<p class="corpo_decreto"><strong class="artigo-decreto">Art. 63. </strong>A residência unifamiliar, enquadrada na subcategoria de uso R1, será licenciada mediante a emissão de Alvará de Aprovação e Execução para Residência Unifamiliar, de acordo com a legislação específica.</p>

	</div>
</template>

<script>
export default{
	name: "Capitulo4",
	props:['caminho']
}
</script>

<style lang="scss">
@import '../assets/main.scss';

/* 04_capitulo-IV_d01.html */
#g-04_capitulo-IV_d01-box .g-artboard {
	margin:0 auto;
}
#g-04_capitulo-IV_d01-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-04_capitulo-IV_d01-01 {
	position:relative;
	overflow:hidden;
	width:960px;
}
#g-04_capitulo-IV_d01-01 p {
	/*font-family:arial,helvetica,sans-serif;*/
	font-size:12px;
	line-height:12px;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0.01em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
	height:auto;
}
#g-04_capitulo-IV_d01-01 .g-pstyle0 {
	font-weight:bold;
	font-size:16px;
	line-height:19px;
	height:19px;
	letter-spacing:-0.003em;
}
#g-04_capitulo-IV_d01-01 .g-pstyle1 {
	font-size:14px;
	line-height:17px;
	height:17px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d01-01 .g-pstyle2 {
	font-weight:bold;
	line-height:14px;
	letter-spacing:0em;
	text-align:center;
}
#g-04_capitulo-IV_d01-01 .g-pstyle3 {
	font-weight:500;
	font-size:7px;
	line-height:9px;
	height:9px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d01-01 .g-pstyle4 {
	font-weight:bold;
	font-size:14px;
	line-height:17px;
	height:17px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d01-01 .g-pstyle5 {
	font-weight:bold;
	font-size:14px;
	line-height:17px;
	height:17px;
}
#g-04_capitulo-IV_d01-01 .g-pstyle6 {
	line-height:14px;
	letter-spacing:0em;
	text-align:center;
}
#g-04_capitulo-IV_d01-01 .g-pstyle7 {
	font-weight:bold;
	font-size:14px;
	line-height:17px;
	height:17px;
	letter-spacing:0em;
	text-align:center;
}
#g-04_capitulo-IV_d01-01 .g-pstyle8 {
	letter-spacing:0em;
}
#g-04_capitulo-IV_d01-01 .g-pstyle9 {
	line-height:14px;
}
#g-04_capitulo-IV_d01-01 .g-pstyle10 {
	font-size:10px;
	height:12px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle0 {
	letter-spacing:-0.01em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle1 {
	letter-spacing:-0.009em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle2 {
	letter-spacing:-0.002em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle3 {
	letter-spacing:0.009em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle4 {
	letter-spacing:0em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle5 {
	font-weight:bold;
}
#g-04_capitulo-IV_d01-01 .g-cstyle6 {
	letter-spacing:0.003em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle7 {
	letter-spacing:0.001em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle8 {
	letter-spacing:0.017em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle9 {
	letter-spacing:0.007em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle10 {
	letter-spacing:-0.004em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle11 {
	letter-spacing:-0.025em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle12 {
	letter-spacing:0.005em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle13 {
	letter-spacing:-0.022em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle14 {
	letter-spacing:-0.013em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle15 {
	letter-spacing:-0.001em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle16 {
	letter-spacing:-0.02em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle17 {
	letter-spacing:-0.059em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle18 {
	letter-spacing:-0.024em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle19 {
	letter-spacing:0.004em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle20 {
	letter-spacing:-0.015em;
}
#g-04_capitulo-IV_d01-01 .g-cstyle21 {
	letter-spacing:-0.023em;
}

/* 04_capitulo-IV_d02.html */
#g-04_capitulo-IV_d02-box .g-artboard {
	margin:0 auto;
}
#g-04_capitulo-IV_d02-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-04_capitulo-IV_d02-01 {
	position:relative;
	overflow:hidden;
	width:960px;
}
#g-04_capitulo-IV_d02-01 p {
	/*font-family:arial,helvetica,sans-serif;*/
	font-size:14px;
	line-height:17px;
	height:auto;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0.01em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
}
#g-04_capitulo-IV_d02-01 .g-pstyle0 {
	font-weight:bold;
	font-size:16px;
	line-height:19px;
	height:19px;
	letter-spacing:-0.003em;
}
#g-04_capitulo-IV_d02-01 .g-pstyle1 {
	height:17px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d02-01 .g-pstyle2 {
	line-height:21px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d02-01 .g-pstyle3 {
	font-weight:bold;
	line-height:21px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d02-01 .g-pstyle4 {
	font-weight:500;
	font-size:12px;
	line-height:15px;
	height:15px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d02-01 .g-pstyle5 {
	font-weight:bold;
	height:17px;
}
#g-04_capitulo-IV_d02-01 .g-pstyle6 {
	font-weight:bold;
	height:17px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d02-01 .g-pstyle7 {
	font-weight:bold;
	height:17px;
	letter-spacing:0.009em;
}
#g-04_capitulo-IV_d02-01 .g-pstyle8 {
	height:17px;
}
#g-04_capitulo-IV_d02-01 .g-pstyle9 {
	height:17px;
	text-align:center;
}
#g-04_capitulo-IV_d02-01 .g-pstyle10 {
	font-weight:bold;
	height:17px;
	text-align:center;
}
#g-04_capitulo-IV_d02-01 .g-pstyle11 {
	height:17px;
	letter-spacing:0.017em;
	text-align:center;
}
#g-04_capitulo-IV_d02-01 .g-pstyle12 {
	height:17px;
	letter-spacing:0.017em;
}
#g-04_capitulo-IV_d02-01 .g-pstyle13 {
	height:17px;
	letter-spacing:0.015em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle0 {
	letter-spacing:0.009em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle1 {
	letter-spacing:0.007em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle2 {
	letter-spacing:0em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle3 {
	letter-spacing:0.01em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle4 {
	letter-spacing:0.006em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle5 {
	letter-spacing:0.016em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle6 {
	letter-spacing:-0.009em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle7 {
	letter-spacing:0.005em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle8 {
	letter-spacing:0.017em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle9 {
	letter-spacing:0.015em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle10 {
	letter-spacing:0.003em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle11 {
	letter-spacing:-0.012em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle12 {
	letter-spacing:0.023em;
}
#g-04_capitulo-IV_d02-01 .g-cstyle13 {
	letter-spacing:0.022em;
}

/* 04_capitulo-IV_d03.html */
#g-04_capitulo-IV_d03-box .g-artboard {
	margin:0 auto;
}
#g-04_capitulo-IV_d03-box .g-artboard p {
	margin:0;
}
.g-aiAbs {
	position:absolute;
}
.g-aiImg {
	display:block;
	width:100% !important;
}
.g-aiPointText p { white-space: nowrap; }
#g-04_capitulo-IV_d03-01 {
	position:relative;
	overflow:hidden;
	width:960px;
}
#g-04_capitulo-IV_d03-01 p {
	/*font-family:arial,helvetica,sans-serif;*/
	font-size:14px;
	line-height:17px;
	filter:alpha(opacity=100);
	-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
	opacity:1;
	letter-spacing:0.01em;
	text-align:left;
	color:rgb(0,0,0);
	text-transform:none;
	padding-bottom:0;
	padding-top:0;
	mix-blend-mode:normal;
	font-style:normal;
	height:auto;
}
#g-04_capitulo-IV_d03-01 .g-pstyle0 {
	font-weight:bold;
	font-size:16px;
	line-height:19px;
	height:19px;
	letter-spacing:-0.003em;
}
#g-04_capitulo-IV_d03-01 .g-pstyle1 {
	height:17px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d03-01 .g-pstyle2 {
	line-height:19px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d03-01 .g-pstyle3 {
	font-weight:bold;
	font-size:16px;
	line-height:19px;
	height:19px;
}
#g-04_capitulo-IV_d03-01 .g-pstyle4 {
	font-weight:bold;
	font-size:16px;
	line-height:19px;
	height:19px;
	letter-spacing:-0.009em;
}
#g-04_capitulo-IV_d03-01 .g-pstyle5 {
	font-weight:bold;
	font-size:16px;
	line-height:19px;
	height:19px;
	letter-spacing:-0.009em;
	text-align:center;
}
#g-04_capitulo-IV_d03-01 .g-pstyle6 {
	font-size:16px;
	line-height:19px;
	height:19px;
}
#g-04_capitulo-IV_d03-01 .g-pstyle7 {
	font-size:16px;
	line-height:19px;
	height:19px;
	letter-spacing:-0.01em;
	text-align:center;
}
#g-04_capitulo-IV_d03-01 .g-pstyle8 {
	font-size:16px;
	line-height:19px;
	height:19px;
	text-align:center;
}
#g-04_capitulo-IV_d03-01 .g-pstyle9 {
	font-size:16px;
	line-height:19px;
	text-align:center;
}
#g-04_capitulo-IV_d03-01 .g-pstyle10 {
	font-weight:500;
	font-size:9px;
	line-height:11px;
	height:11px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d03-01 .g-pstyle11 {
	text-align:center;
}
#g-04_capitulo-IV_d03-01 .g-pstyle12 {
	font-weight:500;
	font-size:13px;
	line-height:15px;
	height:15px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d03-01 .g-pstyle13 {
	font-size:12px;
	line-height:14px;
}
#g-04_capitulo-IV_d03-01 .g-pstyle14 {
	line-height:19px;
	height:19px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d03-01 .g-pstyle15 {
	font-weight:bold;
	height:17px;
	letter-spacing:0em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle0 {
	letter-spacing:-0.032em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle1 {
	letter-spacing:-0.009em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle2 {
	letter-spacing:-0.004em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle3 {
	letter-spacing:-0.022em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle4 {
	letter-spacing:-0.02em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle5 {
	letter-spacing:-0.008em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle6 {
	letter-spacing:-0.013em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle7 {
	letter-spacing:-0.01em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle8 {
	letter-spacing:-0.012em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle9 {
	letter-spacing:0.006em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle10 {
	letter-spacing:-0.033em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle11 {
	letter-spacing:0.007em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle12 {
	letter-spacing:-0.006em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle13 {
	letter-spacing:-0.019em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle14 {
	letter-spacing:-0.005em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle15 {
	letter-spacing:0.009em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle16 {
	letter-spacing:-0.003em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle17 {
	letter-spacing:-0.002em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle18 {
	letter-spacing:0em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle19 {
	letter-spacing:-0.001em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle20 {
	letter-spacing:0.004em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle21 {
	letter-spacing:-0.023em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle22 {
	letter-spacing:0.017em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle23 {
	letter-spacing:0.005em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle24 {
	font-weight:bold;
}
#g-04_capitulo-IV_d03-01 .g-cstyle25 {
	letter-spacing:-0.046em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle26 {
	letter-spacing:0.012em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle27 {
	letter-spacing:-0.039em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle28 {
	letter-spacing:-0.011em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle29 {
	letter-spacing:-0.007em;
}
#g-04_capitulo-IV_d03-01 .g-cstyle30 {
	letter-spacing:-0.029em;
}
</style>


// WEBPACK FOOTER //
// src/components/Capitulo4.vue